export default __webpack_public_path__ + "022aab28ef9f896a9e6bd0e2420ed03d.svg";